import React from 'react';
import Layout from '../Layout';

const Home = () => (
  <Layout className="home">
    <p className="m-5">
      Lietuvių kalbos pastoviųjų žodžių junginių duomenų bazė, pastoviuosius žodžių junginius
      atpažįstantis įrankis ir kiti resursai sukurti vykdant projektus
      „Lietuvių kalbos pastoviųjų žodžių junginių automatinis atpažinimas (PASTOVU)“
      (šį projektą 2016–2018 m. vykdė Vytauto Didžiojo universiteto Kompiuterinės lingvistikos centras
       kartu su Baltijos pažangių technologijų institutu; jį finansavo Lietuvos mokslo taryba
       (projekto nr. LIP-027/2016); plačiau žr. <a href="https://pastovu.vdu.lt/" target="__blank">https://pastovu.vdu.lt/</a>)
       ir „Arbitraliosios lietuvių kalbos kolokacijos: atpažinimas, aprašymas, vartojimas“ (ARKA)
       (šį projektą 2020–2022 m. vykdė Vytauto Didžiojo universiteto Kompiuterinės lingvistikos centras;
       jį finansavo Lietuvos mokslo taryba (projekto nr. S-LIP-20-18); plačiau žr. <a href="https://arka.pastovu.vdu.lt/" target="__blank">https://arka.pastovu.vdu.lt/</a>).
    </p>
  </Layout>
);

export default Home;
